import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'app-factur-promo-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div [class]="variant() === 'inline' ? 'my-6 rounded-xl' : ''"
         class="bg-gradient-to-r from-violet-600 via-purple-600 to-purple-700">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8"
           [class]="variant() === 'inline' ? 'py-4 sm:py-5' : 'py-5 sm:py-6'">
        <div class="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
          <!-- Icon + Text -->
          <div class="flex items-center gap-3 sm:gap-4 flex-1 min-w-0">
            <div class="flex-shrink-0 hidden sm:flex items-center justify-center w-10 h-10 bg-white/15 rounded-lg">
              <svg class="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
              </svg>
            </div>
            <div class="text-center sm:text-left">
              <p class="text-base sm:text-lg font-bold text-white">
                Facturezi? Fa-o simplu, fa-o gratis.
              </p>
              <p class="mt-0.5 text-sm text-purple-100">
                Emite facturi, gestioneaza clienti si tine evidenta platilor — totul pe <strong class="font-semibold text-white">factur.ro</strong>
              </p>
            </div>
          </div>

          <!-- CTA Button -->
          <a href="https://factur.ro?utm_source=datefirma&utm_medium=banner&utm_campaign=promo"
             target="_blank"
             rel="noopener sponsored"
             class="flex-shrink-0 inline-flex items-center gap-2 px-5 py-2.5 bg-white text-purple-700 text-sm font-semibold rounded-lg hover:bg-purple-50 transition-colors shadow-sm">
            Incepe gratuit
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  `,
})
export class FacturPromoBannerComponent {
  readonly variant = input<'banner' | 'inline'>('banner');
}
